import React, { useEffect } from 'react';
import { FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // Make sure you're using react-router-dom v6+

const Course = () => {
  const navigate = useNavigate();

  const handlePayment = () => {
    const options = {
      key: 'rzp_live_7vkw17RunFxN2d',
      amount: 49900, // Amount in paise (₹499)
      currency: 'INR',
      name: 'codingveda',
      description: 'Course Fee',
      image: './images/ms_excel.png',
      handler: function (response) {
        if (response.razorpay_payment_id) {
          localStorage.setItem('paymentSuccess', 'true');
          navigate('/FullStackDashboard');
        }
      },
      prefill: {
        name: 'lokesh kumar rewar',
        email: 'lokeshrewar@gmail.com',
        contact: '95221133660',
      },
      theme: {
        color: '#3399cc',
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
  const handlePaymentDigital = () => {
    const options = {
      key: 'rzp_live_7vkw17RunFxN2d',
      amount: 99900, // Amount in paise (₹999)
      currency: 'INR',
      name: 'codingveda',
      description: 'Course Fee',
      image: './images/ms_excel.png',
      handler: function (response) {
        if (response.razorpay_payment_id) {
          localStorage.setItem('paymentSuccess', 'true');
          navigate('/FullStackDashboard');
        }
      },
      prefill: {
        name: 'lokesh kumar rewar',
        email: 'lokeshrewar@gmail.com',
        contact: '95221133660',
      },
      theme: {
        color: '#3399cc',
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    // Redirect if payment was already made
    const hasPaid = localStorage.getItem('paymentSuccess');
    if (hasPaid === 'true') {
      navigate('/FullStackDashboard');
    }
  }, [navigate]);

  return (
    <div className='container every_page_mg_top'>
      <h2 className='text-center mt-5 mb-4'>Our Courses</h2>
      <div className='row'>
        <div className='col-md-4 mb-4'>
          <div className='card'>
            <img src='./images/full_stack_dev.png' className='card-img-top' alt='img' />
            <div className='card-body'>
              <h6 className='card-title'>Unlock Your Confidence with Full Stack Development!</h6>
              <ul>
                <li>One time course fee</li>
                <li>Batch Mentor "Lokesh Rewar"</li>
                <li>Practice based E-Notes will be provided in order to enhance Development skills</li>
              </ul>
              <h6>
                <b>₹ 499 /-</b><br />
                Price <strike>₹ 1999 /-</strike>
              </h6>
              <div style={{ justifyContent: 'center', display: 'flex' }}>
                <button onClick={handlePayment} className='pay_now_btn'>
                  <FaLock />&nbsp;&nbsp;&nbsp;Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
         <div className='col-md-4 mb-4'>
          <div className='card'>
            <img src='./images/Digital_Marketing.png' className='card-img-top' alt='img' />
            <div className='card-body'>
              <h6 className='card-title'>Unlock Your Confidence with Digital Marketing!</h6>
              <ul>
                <li>One time course fee</li>
                <li>Batch Mentor "Lokesh Rewar"</li>
                <li>Practice based E-Notes will be provided in order to enhance Development skills</li>
              </ul>
              <h6>
                <b>₹ 999 /-</b><br />
                Price <strike>₹ 1999 /-</strike>
              </h6>
              <div style={{ justifyContent: 'center', display: 'flex' }}>
                <button onClick={handlePaymentDigital} className='pay_now_btn'>
                  <FaLock />&nbsp;&nbsp;&nbsp;Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Course;